<template>
  <div class="nav_warp" :class="{navFixe:classFixe}">
    <div class="nav">
      <dl class="clearfix">
        <dt>
          <div class="logoMars3">
            <router-link to="/index"> <img
                src="../assets/img/mars3logo.png"
                alt=""
                srcset=""
              ></router-link>

          </div>
        </dt>
        <dd>
          <router-link
            to="/e1"
            class="navText"
          >
            <p>超值商品</p>
            <p>限时销售</p>
          </router-link>
        </dd>
        <dd>
          <router-link
            to="/e2"
            class="navText"
          >
            <p>免费福利</p>
            <p>大升级</p>
          </router-link>
        </dd>
        <dd>
          <router-link
            to="/e3"
            class="navText"
          >
            <p>每日任务</p>
            <p>奖励大升级</p>
          </router-link>
        </dd>
        <dd>
          <router-link
            to="/e4"
            class="navText"
          >
            <p class="only1List">新兵有福利</p>
          </router-link>
        </dd>
        <dd>
          <router-link
            to="/e5"
            class="navText"
          >
            <p class="only1List">多倍狂欢</p>
          </router-link>
        </dd>
        <dd>
          <router-link
            to="/e6"
            class="navText"
          >
            <p>首次充值</p>
            <p>送豪礼</p>
          </router-link>
        </dd>
      </dl>
    </div>
  </div>
</template>
<script>
export default {
  name: "versionNav",
  data() {
    return {
      classCssOn: false,
      classFixe:false
    };
  },
  mounted(){
    window.addEventListener('scroll',this.navShow)
  },
  methods: {
    cssOn() {
      this.classCssOn = true;
    },
    navShow(){
      var scrollTop= window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 200) {
        this.classFixe = true;
       
      } else {
        this.classFixe = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nav_warp {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #000;
  color: #fff;
  font-size: 18px;
  .nav {
    width: 1200px;
    height: 106px;
    margin: 0 auto;
    dl {
      cursor: pointer;
      dt {
        float: left;
      }
      dd {
        float: left;
        position: relative;

        .navText {
          display: inline-block;
          color: #fff;
          line-height: 24px;
          width: 116px;
          height: 48px;
          padding: 29px 0;
          text-align: center;
          .only1List {
            line-height: 48px;
          }
        }
        &:hover .navText::after {
          content: "";
          width: 100%;
          height: 5px;
          background-color: #fff;
          position: absolute;
          bottom: 0;
          left: 0;
        }
        .router-link-active::after {
          content: "";
          width: 100%;
          height: 5px;
          background-color: #fff;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
    }
  }
}

.navFixe{
  position:fixed;
  background-color: rgba(0, 0, 0,0.6);
  animation:showSlow 1s ;
}

@keyframes showSlow {
  0%{
  background-color: rgba(0, 0, 0, 0);
  }
  100%{
  background-color: rgba(0, 0, 0, 0.6);
  }
}

</style>















// WEBPACK FOOTER //
// src/components/qqsmVersion_nav.vue